import Form from '../Form';
import Logo from '../Logo';
import Footer from '../Footer';

import {  Grid, Card, LinearProgress  } from "@mui/material";
import './App.scss';
import { Reducer } from '../../reducers';
import { connect } from 'react-redux';


interface AppProps {
  redirecting: boolean;
  isMobileDevice: boolean;
}

class App extends React.PureComponent<AppProps, {}> {
  render() {
    const {isMobileDevice} = this.props;
		if(isMobileDevice){
			var element = document.body;
      element && element.parentElement?.classList.add("mobileHtml");
			element && element.classList.add("mobileDevice");
		} else {
			var element = document.body;
      element && element.parentElement?.classList.remove("mobileHtml");
			element && element.classList.remove("mobileDevice");
		}
    const { redirecting } = this.props;
    return (
      <React.Fragment>
        <Grid className="Div-Root">
          <Card className="Div-Card" item>
            <Logo />
            <Form />
          </Card>
          <Footer />
          {redirecting && (
            <LinearProgress
              sx={{
                width: '100%',
                position: 'absolute',
                bottom: 0,
              }}
            />
          )}
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: Reducer) => ({
  redirecting: state.login.redirecting,
  isMobileDevice: state.login.isMobileDevice,
});

export default connect(mapStateToProps, null)(App);
